import EventCollectorContext from 'hooks/context/EventCollector/EventCollectorContext';
import useEventCollectorValue from 'hooks/context/EventCollector/useEventCollectorValue';

export default function EventCollectorContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = useEventCollectorValue();
  return (
    <EventCollectorContext.Provider value={value}>
      {children}
    </EventCollectorContext.Provider>
  );
}
